import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getProveData = async (params: object) => {
  return await GET({ url: Api.getProveData, params, showError: false })
}
